/**
 * Sidebar view component that can be added either to the body or inside individual elements
 * Important setup note: sidebar element must have a .pusher element as a sibling.
 * If inserting sidebar into the body, then .pusher must also be under body tag.
 */
define('uikit/modules/sidebar2',['require','exports','module','underscore','marionette','../mixins/component.mixin','../mixins/sidebar.mixin','../collections/components.container.view','../elements/text','../elements/header','../elements/button','../behaviors/hide.when.collection.empty.behavior','../extra/static.methods'],function(require, exports, module){
  var _                               = require('underscore');
  var Mn                              = require('marionette');
  var ComponentMixin                  = require('../mixins/component.mixin');
  var SidebarMixin                    = require('../mixins/sidebar.mixin');
  var ComponentsContainerView         = require('../collections/components.container.view');
  var TextView                        = require('../elements/text');
  var HeaderView                      = require('../elements/header');
  var ButtonView                      = require('../elements/button');
  var HideWhenCollectionEmptyBehavior = require('../behaviors/hide.when.collection.empty.behavior');
  var StaticMethods                   = require('../extra/static.methods');

  var SidebarActionsView = ComponentsContainerView.extend({
    className: 'actions',
    childView: ButtonView,
    behaviors: {
      HideWhenCollectionEmptyBehavior: {
        behaviorClass: HideWhenCollectionEmptyBehavior
      }
    }
  });

  var SidebarDenyButtonView = ButtonView.extend({
    className: ButtonView.prototype.className + ' deny'
  });

  var SidebarConfirmButtonView = ButtonView.extend({
    className: ButtonView.prototype.className + ' confirm'
  });

  var SidebarHeaderView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'header',

    template: function() { return '<ui name="textView" /><ui name="actionsView" />'; },

    options: {
      text: null
    },

    internalViewOptions: {
      textView: function() {
        return {
          type: HeaderView,
          tagName: 'h4'
        };
      },
      actionsView: function() {
        return _.extend({
          type: SidebarActionsView
        }, Mn._getValue(this.getOption('actions'), this));
      }
    },

    internalViewBindings: {
      textView: {
        text: 'text'
      }
    }

  });

  var SidebarContentView = ComponentsContainerView.extend({
    className: 'content'
  });

  var Sidebar = Mn.ItemView.extend(ComponentMixin).extend(SidebarMixin).extend({

    className: 'ui sidebar',

    template: function() { return '<ui name="headerView" /><ui name="actionsView" /><ui name="contentView" />'; },

    options: {
      color: 'white',
      insertToBody: true,
      size: null,
      visible: false,
      direction: 'right',
      transition: 'overlay',
      dimPage: true,
      width: 'wide', //wide, very wide, fullscreen, thin or '' (for normal)
      preventUnsavedChanges: false,
      destroyOnHidden: true
    },

    triggers: {
      'click .confirm': {
        event: 'confirm',
        stopPropagation: false,
        preventDefault: false
      },
      'click .deny': {
        event: 'deny',
        stopPropagation: false,
        preventDefault: false
      }
    },

    internalViewOptions: {
      headerView: function() {
        return _.extend(
          {
            type: SidebarHeaderView
          },
          Mn._getValue(this.getOption('header'), this)
        );
      },
      actionsView: function() {
        return _.extend(
          {
            type: SidebarActionsView
          },
          Mn._getValue(this.getOption('actions'), this)
        );
      },
      contentView: function() {
        return _.extend(
          { type: SidebarContentView },
          Mn._getValue(this.getOption('content'), this)
        );
      }
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      SidebarMixin.initialize.apply(this, arguments);
    },

    updateAttributes: function() {
      this
        .addClass(this.getOption('direction'), this.getBoolOption('direction'))
        .addClass(this.getOption('size'), this.getBoolOption('size'))
        .addClass(this.getOption('color'), this.getBoolOption('color'))
        .addClass(this.getOption('width'), this.getBoolOption('width'))
    }

  }, StaticMethods);

  Sidebar.DenyButtonView    = SidebarDenyButtonView;
  Sidebar.ConfirmButtonView = SidebarConfirmButtonView;
  Sidebar.ActionsView       = SidebarActionsView;
  Sidebar.HeaderView        = SidebarHeaderView;
  Sidebar.ContentView       = SidebarContentView;

  module.exports = Sidebar;
});

